import i18n from "../../plugins/i18n";

const state = {
  notificationItem: {
    icon: "",
    type: "",
    title: "",
    text: "",
    kind: ""
  },
  notificationId: 1,
  notificationList: []
};

const getters = {
  getNotificationList(state) {
    return state.notificationList;
  }
};

const actions = {
  createNotification({ commit }, { icon, type, title, text, kind }) {
    commit("createNotification", { icon, type, title, text, kind });
  },
  removeNotification({ commit }, { id }) {
    commit("removeNotification", { id });
  },
  hideNotification({ commit }, { id }) {
    commit("hideNotification", { id });
  },
  hideNotificationsByKind({ commit }, { kind }) {
    commit("hideNotificationsByKind", { kind });
  },
  hideAllNotifications({ commit }) {
    commit("hideAllNotifications");
  },
  createErrorNotificationForApiRequest({ dispatch }, res) {
    let errorText = res;
    if (res.response && res.response.data) {
      let key = `message.${res.response.data.id}`;
      if (res.response.data.id && i18n.te(key)) {
        errorText = i18n.t(key);
      } else if (res.response.data.message) {
        errorText = res.response.data.message;
      }
      if (
        res.response.data.errors &&
        typeof res.response.data.errors === "object"
      ) {
        errorText =
          errorText +
          "<br>" +
          Object.entries(res.response.data.errors)
            .map(i => {
              let value = "";
              if (Array.isArray(i[1])) {
                value = i[1].join(";<br>");
              } else {
                value = i[1];
              }
              return `<b>${i[0]}:</b>${value}`;
            })
            .join("<br>");
      }
    }
    dispatch(
      "notificationStore/createNotification",
      {
        text: `${errorText}`,
        type: "error",
        kind: "NotificationForApiRequest"
      },
      { root: true }
    );
  },
  createSuccessNotificationForApiRequest({ dispatch }, { text }) {
    dispatch(
      "notificationStore/hideNotificationsByKind",
      {
        kind: "NotificationForApiRequest"
      },
      { root: true }
    );
    dispatch(
      "notificationStore/createNotification",
      {
        text: `${text}`,
        type: "success",
        kind: "NotificationForApiRequest"
      },
      { root: true }
    );
  }
};

const mutations = {
  createNotification(state, notificationItem) {
    state.notificationList.unshift({
      value: true,
      ...notificationItem,
      id: state.notificationId++
    });
  },
  hideNotification(state, { id }) {
    let notification = state.notificationList.find(function(x) {
      return x.id === id;
    });
    notification.value = false;
  },
  removeNotification(state, { id }) {
    state.notificationList = state.notificationList.filter(x => {
      return x.id !== id;
    });
  },
  hideNotificationsByKind(state, { kind }) {
    state.notificationList = state.notificationList.map(x => {
      if (x.kind === kind) {
        x.value = false;
      }
      return x;
    });
  },
  hideAllNotifications() {
    state.notificationList = state.notificationList.map(x => {
      x.value = false;
      return x;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
